import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';
import { MatInput } from '@angular/material';
import { DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

@Component({
  selector: 'app-errore-log',
  templateUrl: './errore-log.component.html',
  styleUrls: ['./errore-log.component.scss']
})
export class ErroreLogComponent implements OnInit {
  // for reset date piker
  @ViewChild('input', { read: MatInput,  static: false }) input: MatInput
  @ViewChild('input1', { read: MatInput, static: false }) input1: MatInput
  @ViewChild('input2', { read: MatInput, static: false }) input2: MatInput
  @ViewChild('input3', { read: MatInput, static: false }) input3: MatInput

  private ResponseVerifiedClearAlaramsNormalUser$: Subject<any> = new Subject();
  private ResponseVerifiedUnclearAlaramsNormalUser$: Subject<any> = new Subject();

  pipe = new DatePipe('en-US')
  public ClearedAlaramsform: FormGroup;
  public UnClearedAlaramsform: FormGroup;

  public adminEpcUserList: any;
  public role: any;
  public roleName: string;
  page = 1;
  page1 = 1;
  public ClearedAlaramsReqObject: any = {};
  public UnClearedAlaramsReqObject: any = {};
  public ClearedAlaramsDetails: any[];
  public ClearedAlaramsCSVDetails: any[];
  public user_Id: any;
  public unClearedAlaramsDetails: any[];
  public unClearedAlaramsCSVDetails: any[];
  public minDate = new Date();
  public clearStartDate: string;
  public clearEndDate: string;
  public unclearEndDate: string;
  public  unclearStartDate: string;
  public formula: string = "Download_CSV";
  limit = 10;
  clearAlaramsOffset = 0;
  unclearAlaramsOffset = 0;
  clearAlramsCount: any;
  unClearAlramsCount: any;
  showAlarmsTab: any;
  constructor(private fb: FormBuilder, private router: Router, private dashboardService: DashboardService,
    private toastr: ToastrService) {
    this.role = localStorage.role;
    this.user_Id = localStorage.id;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '3') {
      this.roleName = 'wms';
    } else if (this.role == '4') {

      this.roleName = 'normal';
    }
    else if (this.role == '6') {

      this.roleName = 'ze';
    } else if (this.role == '7') {

      this.roleName = 'dg';
    }
  }

  ngOnInit() {

    this.ClearedAlaramsform = this.fb.group({
      clearEnd_dt: ['', Validators.required],
      clearStart_dt: ['', Validators.required]
    });

    this.UnClearedAlaramsform = this.fb.group({
      unclearStart_dt: ['', Validators.required],
      unclearEnd_dt: ['', Validators.required]
    });

    if (this.roleName == 'normal') {

      this.showAlarmsTab = 'UnClearedAlarmsTab';
      this.getUnClearedAlarams(this.unclearAlaramsOffset);
    }
   else if (this.roleName == 'ze' || 'dg') {
      this.showAlarmsTab = 'UnClearedAlarmsTab';
      this.getUnClearedAlaramsZE(this.unclearAlaramsOffset);
    }
  }


showClearedAlarmsTab(tab){
this.showAlarmsTab=tab;
this.clearAlaramsOffset=0;
if(this.roleName == 'normal'){
  this.getClearedAlarams(this.clearAlaramsOffset);
  this.resetUnClearedAlarams();
} else if(this.roleName == 'ze' || this.roleName == 'dg')
{
  this.getClearedAlaramsZE(this.clearAlaramsOffset);
  this.resetUnClearedAlaramsZE();
}
  }
  showUnClearedAlarmsTab(tab){
    this.showAlarmsTab=tab;
    this.unclearAlaramsOffset=0;
    if(this.roleName == 'normal'){
    this.getUnClearedAlarams(this.unclearAlaramsOffset);
     this.resetClearedAlarams();}
     else if(this.roleName == 'ze' || this.roleName == 'dg')
{
  this.getUnClearedAlaramsZE(this.unclearAlaramsOffset);
  this.resetClearedAlaramsZE();}

  }
  // get ClearedAlarams for Normal User
  getClearedAlarams(offset) {

    if(offset==0){   //for Nevigte first page
      this.page = 1
    }

    this.clearStartDate = this.pipe.transform(this.ClearedAlaramsform.controls['clearStart_dt'].value, "yyyy-MM-dd");
    this.clearEndDate = this.pipe.transform(this.ClearedAlaramsform.controls['clearEnd_dt'].value, "yyyy-MM-dd");
    this.ClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.clearStartDate,
      end_date: this.clearEndDate,
      limit:this.limit,
      offset:offset
    }
    this.dashboardService.getNormalUserClearedAlarms(this.ClearedAlaramsReqObject)
      .pipe(takeUntil(this.ResponseVerifiedClearAlaramsNormalUser$))
      .subscribe(
        async result => {
          this.clearAlramsCount=0;
          this.ClearedAlaramsDetails=[];
          if (result.status) {
            this.clearAlramsCount = result.count;
            this.ClearedAlaramsDetails = result.resultObject;
             } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {

          return console.error(err);

        }
      );
  }

 // get ClearedAlarams for ZE User
 getClearedAlaramsZE(offset) {

  if(offset==0){   //for Nevigte first page
    this.page = 1
  }

  this.clearStartDate = this.pipe.transform(this.ClearedAlaramsform.controls['clearStart_dt'].value, "yyyy-MM-dd");
  this.clearEndDate = this.pipe.transform(this.ClearedAlaramsform.controls['clearEnd_dt'].value, "yyyy-MM-dd");
  this.ClearedAlaramsReqObject = {
    user_id: this.user_Id,
    start_date: this.clearStartDate,
    end_date: this.clearEndDate,
    limit:this.limit,
    offset:offset
  }
  this.dashboardService.getZEUserClearedAlarms(this.ClearedAlaramsReqObject)
    .pipe(takeUntil(this.ResponseVerifiedClearAlaramsNormalUser$))
    .subscribe(
      async result => {
        this.clearAlramsCount=0;
        this.ClearedAlaramsDetails=[];
        if (result.status) {
          this.clearAlramsCount = result.count;
          alert( this.clearAlramsCount)
          this.ClearedAlaramsDetails = result.resultObject;
           } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {

        return console.error(err);

      }
    );
}


  // reset value ClearedAlarams For Normal User
  public resetClearedAlarams() {
    // this.input.value = '';
    // this.input1.value = '';
    this.ClearedAlaramsform.controls.clearEnd_dt.setValue('');
    this.ClearedAlaramsform.controls.clearStart_dt.setValue('');
    this.ClearedAlaramsform.reset();
    this.clearAlaramsOffset=0;
    this.getClearedAlarams(this.clearAlaramsOffset);
    // this.getClearedAlarams(0);
  }
 // reset value ClearedAlarams For Normal User
 public resetClearedAlaramsZE() {
  // this.input.value = '';
  // this.input1.value = '';
  this.ClearedAlaramsform.controls.clearEnd_dt.setValue('');
  this.ClearedAlaramsform.controls.clearStart_dt.setValue('');
  this.ClearedAlaramsform.reset();
  this.clearAlaramsOffset=0;
  this.getClearedAlaramsZE(this.clearAlaramsOffset);
  // this.getClearedAlarams(0);
}
  // get UnClearedAlarams for Normal User
  getUnClearedAlarams(offset) {
    if(offset==0){   //for Nevigte first page
      this.page1 = 1
    }

    this.unclearStartDate = this.pipe.transform(this.UnClearedAlaramsform.controls['unclearStart_dt'].value, "yyyy-MM-dd");
    this.unclearEndDate = this.pipe.transform(this.UnClearedAlaramsform.controls['unclearEnd_dt'].value, "yyyy-MM-dd");
    this.UnClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.unclearStartDate,
      end_date: this.unclearEndDate,
      limit:this.limit,
      offset:offset
    }

    this.dashboardService.getNormalUserUnClearedAlarms(this.UnClearedAlaramsReqObject)
    .pipe(takeUntil(this.ResponseVerifiedUnclearAlaramsNormalUser$))
    .subscribe(
      async result => {
        this.unClearAlramsCount=0;
        this.unClearedAlaramsDetails=[];
        if (result.status) {
          this.unClearAlramsCount=result.count;
          this.unClearedAlaramsDetails = result.resultObject;

        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
  }

  // get UnClearedAlarams for ZE User
  getUnClearedAlaramsZE(offset) {
    if(offset==0){   //for Nevigte first page
      this.page1 = 1
    }

    this.unclearStartDate = this.pipe.transform(this.UnClearedAlaramsform.controls['unclearStart_dt'].value, "yyyy-MM-dd");
    this.unclearEndDate = this.pipe.transform(this.UnClearedAlaramsform.controls['unclearEnd_dt'].value, "yyyy-MM-dd");
    this.UnClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.unclearStartDate,
      end_date: this.unclearEndDate,
      limit:this.limit,
      offset:offset
    }

    this.dashboardService.getZEUserUnClearedAlarms(this.UnClearedAlaramsReqObject)
    .pipe(takeUntil(this.ResponseVerifiedUnclearAlaramsNormalUser$))
    .subscribe(
      async result => {
        this.unClearAlramsCount=0;
        this.unClearedAlaramsDetails=[];
        if (result.status) {
          this.unClearAlramsCount=result.count;
          this.unClearedAlaramsDetails = result.resultObject;

        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );
  }
  // reset value UnClearedAlarams For Normal User
  public resetUnClearedAlarams() {
    // this.input2.value = '';
    // this.input3.value = '';

    this.UnClearedAlaramsform.controls.unclearStart_dt.setValue('');
    this.UnClearedAlaramsform.controls.unclearEnd_dt.setValue('');
    this.UnClearedAlaramsform.reset();
    this.unclearAlaramsOffset=0;
    this.getUnClearedAlarams(this.unclearAlaramsOffset);
    // this.getUnClearedAlarams(0);
  }
  // reset value UnClearedAlarams For ZE User
  public resetUnClearedAlaramsZE() {
    // this.input2.value = '';
    // this.input3.value = '';

    this.UnClearedAlaramsform.controls.unclearStart_dt.setValue('');
    this.UnClearedAlaramsform.controls.unclearEnd_dt.setValue('');
    this.UnClearedAlaramsform.reset();
    this.unclearAlaramsOffset=0;
    this.getUnClearedAlaramsZE(this.unclearAlaramsOffset);
    // this.getUnClearedAlarams(0);
  }

   //pagination for Unclear alarm for normal user
  nextPageUnclearAlarm(pageIndex): void {
    this.unclearAlaramsOffset = (pageIndex - 1) * 10;
    this.getUnClearedAlarams(this.unclearAlaramsOffset);
  }

   //pagination for Unclear alarm for ZE user
   nextPageUnclearAlarmZE(pageIndex): void {
    this.unclearAlaramsOffset = (pageIndex - 1) * 10;
    this.getUnClearedAlaramsZE(this.unclearAlaramsOffset);
  }
  //pagination for ClearAlarm alarm for normal user
  nextPageClearAlarm(pageIndex): void {
    this.clearAlaramsOffset = (pageIndex - 1) * 10;
    this.getClearedAlarams(this.clearAlaramsOffset);
  }


   //pagination for ClearAlarm alarm for ZE user
   nextPageClearAlarmZE(pageIndex): void {
    this.clearAlaramsOffset = (pageIndex - 1) * 10;
    this.getClearedAlaramsZE(this.clearAlaramsOffset);
  }

  // download csv of cleared alarams NORMAL
  downloadClearedAlarams(){
    this.clearStartDate = this.pipe.transform(this.ClearedAlaramsform.controls['clearStart_dt'].value, "yyyy-MM-dd");
    this.clearEndDate = this.pipe.transform(this.ClearedAlaramsform.controls['clearEnd_dt'].value, "yyyy-MM-dd");
    this.ClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.clearStartDate,
      end_date: this.clearEndDate,
      limit:'0',
      offset:'0'
    }
    this.dashboardService.getNormalUserClearedAlarms(this.ClearedAlaramsReqObject)
      .pipe(takeUntil(this.ResponseVerifiedClearAlaramsNormalUser$))
      .subscribe(
        async result => {

          this.ClearedAlaramsCSVDetails=[];
          if (result.status) {
           this.ClearedAlaramsCSVDetails = result.resultObject;

           var data = this.ClearedAlaramsCSVDetails;
           var options = {
             title: 'Cleared Alarms',
             fieldSeparator: ',',
             quoteStrings: '"',
             decimalseparator: '.',
             showLabels: true,
             showTitle: true,
             useBom: true,
             headers: ['Device Name', ' Name', 'Inverter Name', 'Alarm Id', 'Occurance Time','Clearance Time ', 'Alarm Message']
            };

           new Angular5Csv(data, this.formula, options);



          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {

          return console.error(err);

        }
      );

  }

   // download csv of cleared alarams ZE
   downloadClearedAlaramsZE(){
    this.clearStartDate = this.pipe.transform(this.ClearedAlaramsform.controls['clearStart_dt'].value, "yyyy-MM-dd");
    this.clearEndDate = this.pipe.transform(this.ClearedAlaramsform.controls['clearEnd_dt'].value, "yyyy-MM-dd");
    this.ClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.clearStartDate,
      end_date: this.clearEndDate,
      limit:'0',
      offset:'0'
    }
    this.dashboardService.getZEUserClearedAlarms(this.ClearedAlaramsReqObject)
      .pipe(takeUntil(this.ResponseVerifiedClearAlaramsNormalUser$))
      .subscribe(
        async result => {

          this.ClearedAlaramsCSVDetails=[];
          if (result.status) {
           this.ClearedAlaramsCSVDetails = result.resultObject;

           var data = this.ClearedAlaramsCSVDetails;
           var options = {
             title: 'Cleared Alarms',
             fieldSeparator: ',',
             quoteStrings: '"',
             decimalseparator: '.',
             showLabels: true,
             showTitle: true,
             useBom: true,
             headers: ['Device Name', ' Name', 'Inverter Name', 'Alarm Id', 'Occurance Time','Clearance Time ', 'Alarm Message']
            };

           new Angular5Csv(data, this.formula, options);



          } else if (!result.status) {
            if (result.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(result.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(result.message);

            }

          }
        },
        err => {

          return console.error(err);

        }
      );

  }


  //download csv of uncleared alarams NORMAL
  downloadCSVUnClearedAlarams(){
    this.unclearStartDate = this.pipe.transform(this.UnClearedAlaramsform.controls['unclearStart_dt'].value, "yyyy-MM-dd");
    this.unclearEndDate = this.pipe.transform(this.UnClearedAlaramsform.controls['unclearEnd_dt'].value, "yyyy-MM-dd");
    this.UnClearedAlaramsReqObject = {
      user_id: this.user_Id,
      start_date: this.unclearStartDate,
      end_date: this.unclearEndDate,
      limit:'0',
      offset:'0'
    }
    this.dashboardService.getNormalUserUnClearedAlarms(this.UnClearedAlaramsReqObject)
    .pipe(takeUntil(this.ResponseVerifiedUnclearAlaramsNormalUser$))
    .subscribe(
      async result => {
        this.unClearedAlaramsCSVDetails=[];
        if (result.status) {
          this.unClearedAlaramsCSVDetails = result.resultObject;
          var data = this.unClearedAlaramsCSVDetails;
          var options = {
            title: 'Un-cleared Alarms',
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            showTitle: true,
            useBom: true,
            headers: ['Device Name', 'Name', 'Inverter Name', 'Alarm Id', 'Occurance Time',  'Alarm Message']
          };

          new Angular5Csv(data, this.formula, options);


        } else if (!result.status) {
          if (result.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(result.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(result.message);

          }

        }
      },
      err => {
        return console.error(err);
      }
    );


  }
 //download csv of uncleared alarams ZE
 downloadCSVUnClearedAlaramsZE(){
  this.unclearStartDate = this.pipe.transform(this.UnClearedAlaramsform.controls['unclearStart_dt'].value, "yyyy-MM-dd");
  this.unclearEndDate = this.pipe.transform(this.UnClearedAlaramsform.controls['unclearEnd_dt'].value, "yyyy-MM-dd");
  this.UnClearedAlaramsReqObject = {
    user_id: this.user_Id,
    start_date: this.unclearStartDate,
    end_date: this.unclearEndDate,
    limit:'0',
    offset:'0'
  }
  this.dashboardService.getZEUserUnClearedAlarms(this.UnClearedAlaramsReqObject)
  .pipe(takeUntil(this.ResponseVerifiedUnclearAlaramsNormalUser$))
  .subscribe(
    async result => {
      this.unClearedAlaramsCSVDetails=[];
      if (result.status) {
        this.unClearedAlaramsCSVDetails = result.resultObject;
        var data = this.unClearedAlaramsCSVDetails;
        var options = {
          title: 'Un-cleared Alarms',
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: true,
          showTitle: true,
          useBom: true,
          headers: ['Device Name', 'Name', 'Inverter Name', 'Alarm Id', 'Occurance Time',  'Alarm Message']
        };

        new Angular5Csv(data, this.formula, options);


      } else if (!result.status) {
        if (result.message == 'Unauthorised or Login Time-out') {
          this.toastr.info(result.message);
          this.router.navigate(["/login"]);

        } else {
          this.toastr.info(result.message);

        }

      }
    },
    err => {
      return console.error(err);
    }
  );


}
  ngOnDestroy() {

    this.ResponseVerifiedClearAlaramsNormalUser$.next();
    this.ResponseVerifiedClearAlaramsNormalUser$.complete();

    this.ResponseVerifiedUnclearAlaramsNormalUser$.next();
    this.ResponseVerifiedUnclearAlaramsNormalUser$.complete()
  }
}
